// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_rY3xH8","source":"ob_2MmXGH","credit":"ob_LNtfAt","credit__icon":"ob_GC7UmU","creditInformation":"ob_bXXcdW"};